import { render, staticRenderFns } from "./LgFinderPageUnidadeAdministrativa.vue?vue&type=template&id=67f818f9&scoped=true"
import script from "./LgFinderPageUnidadeAdministrativa.vue?vue&type=script&lang=js"
export * from "./LgFinderPageUnidadeAdministrativa.vue?vue&type=script&lang=js"
import style0 from "./LgFinderPageUnidadeAdministrativa.vue?vue&type=style&index=0&id=67f818f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f818f9",
  null
  
)

export default component.exports